import script from "./ExpendeduriaItemComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpendeduriaItemComponent.vue?vue&type=script&setup=true&lang=js"

import "./ExpendeduriaItemComponent.vue?vue&type=style&index=0&id=b6f2cbb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6f2cbb8"]])

export default __exports__